import request from '../request';
import { url } from './config';
import { SyncJobRequest, S3Snapshot, SyncSchedule } from './types';

const handleData = (res: any) => res.data;

class DataSyncApi {
    startSync(body: SyncJobRequest) {
        return request.post(`${url}-run`, body, { timeout: 0 }).then(handleData);
    }

    getStreamUrl(jobId: string) {
        return `/api${url}-stream/${jobId}`;
    }

    getDbManagerStreamUrl(jobId: string) {
        return `/api/db-manager-stream/${jobId}`;
    }

    stopJob(jobId: string) {
        return request.post(`${url}-stop/${jobId}`).then(handleData);
    }

    getDbInfo() {
        return request.get(`${url}-db-info`).then(handleData);
    }

    // S3 Snapshot management
    getSnapshots(): Promise<S3Snapshot[]> {
        return request.get(`${url}-snapshots`).then(handleData);
    }

    startExport(importDb?: string): Promise<{ jobId: string }> {
        return request.post(`${url}-export`, { importDb }).then(handleData);
    }

    startS3Import(snapshot: string, targetDb: string): Promise<{ jobId: string }> {
        return request.post(`${url}-s3-import`, { snapshot, targetDb }).then(handleData);
    }

    deleteSnapshot(snapshot: string): Promise<{ message: string }> {
        return request.post(`${url}-snapshot-delete`, { snapshot }).then(handleData);
    }

    // Schedule
    getSchedule(): Promise<SyncSchedule> {
        return request.get(`${url}-schedule`).then(handleData);
    }

    saveSchedule(schedule: SyncSchedule): Promise<{ message: string }> {
        return request.post(`${url}-schedule`, schedule).then(handleData);
    }

    runScheduleNow(opts: { skipRedshiftRefresh?: boolean } = {}): Promise<{ message: string; jobId?: string }> {
        return request.post(`${url}-schedule-run`, opts).then(handleData);
    }

    getScheduleRuns(): Promise<any[]> {
        return request.get(`${url}-schedule-runs`).then(handleData);
    }

    getScheduleRunStatus(): Promise<{ running: boolean; startedAt: string | null; trigger: string | null }> {
        return request.get(`${url}-schedule-run-status`).then(handleData);
    }

    // DB Manager
    listDatabases(env: string): Promise<{ databases: string[] }> {
        return request.get(`/db-manager-databases?env=${env}`).then(handleData);
    }

    runDbManagerAction(body: { action: string; env?: string; target?: string; filename?: string; mode?: string; dynamicOnly?: boolean; sourceDb?: string; targetDb?: string }): Promise<{ jobId: string }> {
        return request.post('/db-manager-run', body).then(handleData);
    }

    stopDbManagerJob(jobId: string) {
        return request.post(`/db-manager-stop/${jobId}`).then(handleData);
    }

    listBackups(env?: string) {
        return request.get(`/db-manager-backups${env ? `?env=${env}` : ''}`).then(handleData);
    }

    getActiveDb(): Promise<{ env: string; host: string; port: string; user: string; database: string; isDocker: boolean; isEcs: boolean }> {
        return request.get('/db-manager-active-db').then(handleData);
    }

    setActiveDb(env: string, database: string): Promise<{ message: string; restartRequired: boolean }> {
        return request.post('/db-manager-active-db', { env, database }).then(handleData);
    }
}

export default new DataSyncApi();
